export default (context, inject) => {
  const validateForm = (element) => {
    context.store.commit('utils/clearFormErrors');
    const form = element.tagName === 'FORM' ? element : element.querySelector('form');
    if (form) {
      form.querySelectorAll('input, select').forEach(el => {
        el.checkValidity();
      });
      return form.reportValidity();
    }
  };
  inject('validateForm', validateForm);
  context.$validateForm = validateForm;
};
